import api from '@motionelements/core/src/api/base-api-v2';
// import { snakeCaseKeys } from '../helpers/string';

export const listChannelTitleDescription = async () => {
  const request = await api.request('get', '/v2/channels', {
    params: api.getLocaleParams(),
  });
  return request;
};

export const getChannelBanners = async () => {
  const request = api.request('get', '/v2/channel/banners', {
    params: api.getLocaleParams(),
  });
  return request;
};

export const getChannelPosts = async () => {
  const request = api.request('get', '/v2/channel/posts', {
    params: api.getLocaleParams(),
  });
  return request;
};

export const getChannelsHomeStats = async () => {
  const request = await api.request('get', '/v2/channels/home/stats', {
    params: api.getLocaleParams(),
  });
  return request;
};

export const getChannelsHomeNewElements = async () => {
  const request = await api.request('get', '/v2/channels/home/new-elements', {
    params: api.getLocaleParams(),
  });
  return request;
};

export const listChannelCategoryTree = async (mediaType, params) => {
  mediaType = mediaType.replace('_', '-');
  // params = params ? snakeCaseKeys(params) : {};
  params = params || {};
  return api.get(`/v2/channels/${mediaType}/category-tree`, {
    withCredentials: false,
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
  });
};
